import AmchartPie from './amchart-pie'
import AmchartXY from './amchart-xy'

AmchartPie.install = function(Vue) {
    Vue.component(AmchartPie.name, AmchartPie);

};

AmchartXY.install = function(Vue) {
    Vue.component(AmchartXY.name, AmchartXY);

};

export default {
    AmchartPie,
    AmchartXY
}



// WEBPACK FOOTER //
// ./src/components/amcharts/index.js